import { Truck } from "lucide-react";
import { HeaderPortal } from "@/components/src/header-portal/header-portal.component";
import { PageTitle } from "@components/page-title/page-title.component";
import { DashboardDeliveries } from "../dashboard/components/dashboard-deliveries.component";

export const DeliveriesPage: React.FC = () => {
	return (
		<div className="w-full h-full flex flex-col">
			<HeaderPortal>
				<PageTitle
					icon={<Truck size={16} />}
					title={[{ name: "Lieferungen" }]}
				/>
			</HeaderPortal>
			<div className="px-2 h-full w-full flex flex-col pt-2">
				<DashboardDeliveries />
			</div>
		</div>
	);
};
